<template>
  <div class="partner-logo-layout" @click="select($event)">
    <div class="overlay"></div>
    <i class="material-icons left" v-if="columnNumber == '5'">chevron_left</i>
    <i class="material-icons right" v-if="columnNumber == '5'">chevron_right</i>
    <img :src="$images.blueTick" v-if="selectedColumnSet == columnNumber" />
    <div
      class="col-select"
      :class="{
        selected: selectedColumnSet == columnNumber,
        wrap: columnNumber == '8',
      }"
    >
      <div v-for="(n, idx) in columnNumber" :key="idx"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columnNumber: {
      type: Number,
    },
    selectedColumnSet: {
      type: Number,
    },
  },
  data() {
    return {
      selectedLayout: null,
    };
  },
  methods: {
    select() {
      this.$emit("activeSelect", this.columnNumber);
    },
  },
};
</script>

<style scoped lang='scss'>
.partner-logo-layout {
  position: relative;
  height: 60px;
  .material-icons {
    position: absolute;
    font-size: 20px;
    top: 50%;
    transform: translateY(-50%);
    &.left {
      right: 90%;
    }
    &.right{
      left: 90%;
    }
  }
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .col-select {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 150px;
    height: 60px;
    border: 1px solid #cbcbe4;
    padding: 5px;
    margin: 0 0 10px 0;
    cursor: pointer;
    &.selected {
      border-color: #2295d6;
    }
    &.wrap {
      flex-wrap: wrap;

      div {
        width: 31px;
        height: 24px;
        flex-basis: unset;
      }
    }
    div {
      background: #cbcbe4;
      flex-basis: 100%;
      text-align: center;
      border: 1px solid #fff;
      height: 100%;
      margin: 0 1px;
    }
  }
  span {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #001529;
  }
  img {
    position: absolute;
    width: 20px;
    left: calc(100% - 10px);
    bottom: calc(100% - 5px);
  }
}
</style>